import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiUrl } from '../constants/api-url';
import { getRoleContext, userRoleContext } from '../constants/role-details.constants';
import { catchError } from 'rxjs';

@Injectable({
  providedIn: 'any'
})
export class HelperService {
  private httpClient = inject(HttpClient);
  buyerObj: any;
  token: any;

  getRequestVerificationToken(): any {
    if (window.parent.document.getElementsByName('__RequestVerificationToken').length > 0) {
      let list: any = window.parent.document.getElementsByName('__RequestVerificationToken');
      list.forEach((element: any) => {
        this.token = element.value;
      });
      return this.token;
    }
  }
  // 
  getBuyerId() {
    return this.httpClient.get(`${ApiUrl.GET_INFO_URL}`).pipe(
      catchError((error) => {
        return error;
      })
    );
  }
  getRequestDownloadTemplate(templateField: string): any {
    let download: any;
    if (window.parent.document.getElementsByName(templateField).length > 0) {
      let list: any = window.parent.document.getElementsByName(templateField);
      list.forEach((element: any) => {
        download = element.value;
      });
      return download;
    }
  }

    getSettingValueByKey(settingKey: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    // SM-3426: Supplier (SEM/LMC) logins must hit the Supplier-area endpoint; the Buyer endpoint
    // is gated to UserRoleContext.Buyer and returns 403 for them. Both return { success, data }.
    const baseUrl = getRoleContext() === userRoleContext.Supplier
      ? ApiUrl.SUPPLIER_GET_SETTING_VALUE
      : ApiUrl.GET_SETTING_VALUE;
    return this.httpClient.get(`${baseUrl}${settingKey}`, { headers }).pipe(
            catchError((error) => {
        return error;
      })
    );
  }
}
